import { Injectable } from '@angular/core';
import { SideMenuService } from '@services/menu/side-menu.service';
import { ProfileService } from '@services/profile/profile.service';
import { AddinExecute, Execute } from '@techwan/ionic-core';
import { filter, first } from 'rxjs';
import { MessagesMenuEntry } from '../../../schema/messages-menu-entry';
import { MessagesMenuControllerService } from '../../messages-menu-controller/messages-menu-controller.service';

@AddinExecute({
  name: 'Add menu to access media messages'
})
@Injectable()
export class MessagesMenuSetupService extends Execute {
  private messagesMenuEntry = new MessagesMenuEntry();

  constructor(
    private sideMenu: SideMenuService,
    private profile: ProfileService,
    private messagesMenuController: MessagesMenuControllerService
  ) {
    super();
  }

  execute(): void {
    this.profile.ready
      .pipe(
        filter(isReady => isReady),
        first()
      )
      .subscribe(() => this.setup());
  }

  private setup() {
    this.sideMenu.addMenuEntry(this.messagesMenuEntry);
    this.messagesMenuController.setup(this.messagesMenuEntry);
  }
}
